
import { animate, animateChild, group, query, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterModule, RouterOutlet } from '@angular/router';
import { Subject } from 'rxjs';
import { skip, takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/auth.service';
import { SystemService } from 'src/app/system.service';
import { NavBarComponent } from '../nav-bar/nav-bar.component';




@Component( {
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    imports: [RouterModule, NavBarComponent],
    animations: [
        trigger( 'routerTransition', [
            // `:scope >` keeps the queries on the routed page itself. A bare
            // ':enter' also matches every element the page renders in the same
            // pass (e.g. @for items), stacking them all at top: 0.
            transition( '* <=> *', [
                query( ':scope > :enter, :scope > :leave', style( { position: 'absolute', width: '100%', top: '0', left: '0' } ), { optional: true } ),
                query( ':scope > :enter', style( { opacity: 0 } ), { optional: true } ),
                query( ':scope > :leave', animateChild(), { optional: true } ),
                group( [
                    query( ':scope > :leave', [animate( '.5s ease-out', style( { opacity: 0 } ) )], { optional: true } ),
                    query( ':scope > :enter', [animate( '.5s ease-out', style( { opacity: 1 } ) )], { optional: true } )
                ] ),
                query( ':scope > :enter', animateChild(), { optional: true } )
            ] ),
        ] )
    ],
    
} )
export class MainComponent implements OnInit, OnDestroy {
	afAuth = inject( AuthService );
	ss = inject( SystemService );
	router = inject( Router );
	activatedRoute = inject( ActivatedRoute );

	private destroy$ = new Subject<void>();
	public isEmailVerified = false;
	@ViewChild( 'container', { static: true } ) htmlContainer: ElementRef

	ngOnInit () {
		const actorType = this.afAuth.user?.actorType;
		if ( actorType === 'contact' || actorType === 'vendor' ) {
			this.htmlContainer.nativeElement.style.overflow = 'unset';
		}

		// Set initial value synchronously from JWT so navbar shows immediately without flicker
		this.isEmailVerified = !!this.afAuth.user?.isVerified;

		// skip(1) skips the BehaviorSubject's immediate replay of its current value
		// (already applied above). Every subsequent emission — including null on logout — is
		// applied directly, so contacts/vendors correctly hide the navbar on sign out.
		this.afAuth.currentUserData.pipe( skip( 1 ), takeUntil( this.destroy$ ) ).subscribe( ( user ) => {
			this.isEmailVerified = !!user?.isVerified;
		} );
	}

	ngOnDestroy (): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	getAnimationState ( outlet: RouterOutlet ) {
		return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animateState;
	}

}
